import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { IMedia, IPatient } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { NgMediaManagerModule } from '@principle-theorem/ng-media-manager';
import { ButtonsContainerComponent } from '@principle-theorem/ng-shared';

export interface IMohPatientAttachmentsDialogData {
  media: WithRef<IMedia>[];
  patient: WithRef<IPatient>;
}

@Component({
  selector: 'pr-moh-patient-attachments-dialog',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatDialogModule,
    NgMediaManagerModule,
    MatButtonModule,
    ButtonsContainerComponent,
  ],
  templateUrl: './moh-patient-attachments-dialog.component.html',
  styleUrl: './moh-patient-attachments-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohPatientAttachmentsDialogComponent {
  dialogRef =
    inject<
      MatDialogRef<MohPatientAttachmentsDialogComponent, WithRef<IMedia>[]>
    >(MatDialogRef);
  data = inject<IMohPatientAttachmentsDialogData>(MAT_DIALOG_DATA);
  selectedMediaItems = signal<WithRef<IMedia>[]>([]);
}
